<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>

    <!-- 头部信息 -->
    <div class="form_content">
      <div class="form_item">
        <span>检票人：</span>
        <div class="form_input">{{ checkModifyName }}</div>
      </div>
      <div class="form_item">
        <span>日期：</span>
        <div class="form_input">{{ checkStartDate }} ~ {{ checkEndDate }}</div>
      </div>
    </div>

    <!-- 检票明细列表 -->
    <van-list
        class="m-1"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
        ref="list"
    >
      <div class="order_panel mt-1" v-for="(item, index) in list" :key="index">
        <div class="panel_index">{{ index + 1 }}</div>
        <div class="panel_item">
          <div class="panel_item_content">
            <p class="item_content_label">车牌号:</p>
            <p class="item_content_info flex-1">{{ item.vehicleNo }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">线路:</p>
            <p class="item_content_info flex-1">{{ item.lineName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">上车站点:</p>
            <p class="item_content_info flex-1">{{ item.startNodeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">到达站点:</p>
            <p class="item_content_info flex-1">{{ item.arrivalNodeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">班次时间:</p>
            <p class="item_content_info flex-1">{{ item.classDateTime }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">电话:</p>
            <p class="item_content_info flex-1">{{ item.custTel }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">票价:</p>
            <p class="item_content_info flex-1">{{ item.ticketPrice }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">检票时间:</p>
            <p class="item_content_info flex-1">{{ item.checkTime }}</p>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "检票明细",
      loading: false,
      finished: false,
      current: 1,
      size: 10,
      list: [],
      checkStartDate: this.$route.query.checkStartDate || "",
      checkEndDate: this.$route.query.checkEndDate || "",
      checkGID: this.$route.query.checkGID || "",
      checkModifyName: this.$route.query.checkModifyName || "",
    };
  },
  mounted() {
    this.$refs.list.check();
  },
  methods: {
    // 加载明细列表
    onLoad() {
      if (!this.checkGID) {
        this.loading = false;
        this.finished = true;
        return;
      }
      const params = {
        checkStartDate: this.$moment(this.checkStartDate).format("YYYY-MM-DD"),
        checkEndDate: this.$moment(this.checkEndDate).format("YYYY-MM-DD"),
        checkGID: this.checkGID,
        current: this.current,
        size: this.size,
      };
      this.$http
          .post(this.$api.getTicketCheckListDetail, params)
          .then((res) => {
            const isSuccess = res.success || res.code == 200;
            if (isSuccess) {
              const records = res.data && res.data.records ? res.data.records : [];
              const total = res.data && res.data.total ? res.data.total : records.length;
              records.forEach((item) => {
                this.list.push(item);
              });
              this.current++;
              if (this.list.length >= total) {
                this.finished = true;
              }
            }
          })
          .catch(() => {
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.form_content {
  padding-bottom: 15px;
  background-color: #fff;

  .form_item {
    display: flex;
    flex: 1;
    padding: 0.256rem;
    line-height: 0.75rem;
    box-sizing: border-box;

    .form_input {
      border-bottom: 1px solid #000;
      min-width: 2.692rem;
      flex: 1;
      font-size: 0.359rem;
    }
  }
}

.order_panel {
  border-radius: 10px;
  padding: 0.15rem;
  background-color: #fff;
  text-align: left;
  position: relative;

  .panel_index {
    width: 0.5333rem;
    height: 0.5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    text-align: center;
    color: #fff;
    background-color: #f7a33c;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }

  .panel_item {
    .panel_item_content {
      display: flex;
      line-height: 0.5rem;
      min-height: 1rem;

      .item_content_label {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d8d8d8;
        background-color: #f9f9f9;
      }

      .item_content_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #d8d8d8;
        padding: 0 5px;
      }
    }
  }
}
</style>
